const initialState = {
  sidebarShow: true,
  footerShow: false,
}

export const sidebar = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    case 'footer':
      return { ...state, ...rest }
    default:
      return state
  }
}
